/*global define: false */
define('validateAll',['jquery',
        'validate',
        'unobtrusive',
        'validateUniqueEmail',
        'validatePassword',
        'validateMaskedDate',
        'validateMaskedPhone'], function ($) {

            'use strict';

            $.validator.setDefaults({
                onkeyup: function (element) {
                    var $element = $(element);

                    // if the nokeypress data-attribute is present, never validate on keypress
                    if ($element.data('nokeypress')) {
                        return;
                    }

                    // if the force-keypress data-attribute is present, validate on EVERY keypress
                    if ($element.data('force-keypress')) {
                        this.element(element);
                        return;
                    }

                    // default behavior of onkeyup taken from https://github.com/jzaefferer/jquery-validation/blob/master/src/core.js
                    if (element.name in this.submitted || element === this.lastElement) {
                        this.element(element);
                    }
                }
            });

            // by default $.validator.unobtrusive.parse() is run on document.ready.
            // if that event has already fired, our custom validators were not included
            // and we need to re-initialize everything.
            if ($.isReady) {
                $('form')
                    .removeData('validator')
                    .removeData('unobtrusiveValidation');

                $.validator.unobtrusive.parse($(document));
            }
        });
